import { mode } from '@chakra-ui/theme-tools';
export const inputStyles = {
  components: {
    Input: {
      baseStyle: {
        field: {
          fontWeight: 400,
          borderRadius: '18px',
        },
      },

      variants: {
        main: (props) => ({
          field: {
            bg: mode('transparent', 'navy.800')(props),
            border: '1px solid',
            color: mode('secondaryGray.900', 'white')(props),
            borderColor: mode(
              'rgba(162, 176, 210, 0.28)',
              'rgba(255,255,255,0.08)',
            )(props),
            borderRadius: '18px',
            fontSize: 'md',
            p: '24px',
            bgColor: mode(
              'rgba(255,255,255,0.64)',
              'rgba(255,255,255,0.05)',
            )(props),
            _placeholder: { color: 'secondaryGray.600' },
            _hover: {
              borderColor: mode(
                'rgba(111, 66, 193, 0.22)',
                'rgba(174, 134, 242, 0.28)',
              )(props),
            },
            _focusVisible: {
              borderColor: mode('brand.400', 'brand.300')(props),
              boxShadow: mode(
                '0 0 0 4px rgba(111, 66, 193, 0.10)',
                '0 0 0 4px rgba(174, 134, 242, 0.12)',
              )(props),
            },
          },
        }),
        auth: (props) => ({
          field: {
            fontWeight: '600',
            color: mode('navy.700', 'white')(props),
            bg: mode('rgba(255,255,255,0.74)', 'rgba(255,255,255,0.05)')(props),
            border: '1px solid',
            borderColor: mode(
              'rgba(162, 176, 210, 0.24)',
              'rgba(255, 255, 255, 0.08)',
            )(props),
            borderRadius: '18px',
            _placeholder: { color: 'secondaryGray.600', fontWeight: '500' },
            _focusVisible: {
              borderColor: mode('brand.400', 'brand.300')(props),
              boxShadow: mode(
                '0 0 0 4px rgba(111, 66, 193, 0.10)',
                '0 0 0 4px rgba(174, 134, 242, 0.12)',
              )(props),
            },
          },
        }),
        authSecondary: (props) => ({
          field: {
            bg: 'transparent',
            border: '1px solid',
            borderColor: 'rgba(162, 176, 210, 0.24)',
            borderRadius: '18px',
            _placeholder: { color: 'secondaryGray.600' },
          },
        }),
        search: (props) => ({
          field: {
            border: 'none',
            py: '14px',
            borderRadius: 'inherit',
            _placeholder: { color: 'secondaryGray.600' },
          },
        }),
      },
    },
    NumberInput: {
      baseStyle: {
        field: {
          fontWeight: 400,
        },
      },

      variants: {
        main: (props) => ({
          field: {
            bg: 'transparent',
            border: '1px solid',

            borderColor: 'secondaryGray.100',
            borderRadius: '16px',
            _placeholder: { color: 'secondaryGray.600' },
          },
        }),
        auth: (props) => ({
          field: {
            bg: 'transparent',
            border: '1px solid',

            borderColor: 'secondaryGray.100',
            borderRadius: '16px',
            _placeholder: { color: 'secondaryGray.600' },
          },
        }),
        authSecondary: (props) => ({
          field: {
            bg: 'transparent',
            border: '1px solid',

            borderColor: 'secondaryGray.100',
            borderRadius: '16px',
            _placeholder: { color: 'secondaryGray.600' },
          },
        }),
        search: (props) => ({
          field: {
            border: 'none',
            py: '11px',
            borderRadius: 'inherit',
            _placeholder: { color: 'secondaryGray.600' },
          },
        }),
      },
    },
    Select: {
      baseStyle: {
        field: {
          fontWeight: 400,
        },
      },

      variants: {
        main: (props) => ({
          field: {
            bg: mode('transparent', 'navy.800')(props),
            border: '1px solid',
            color: mode('secondaryGray.900', 'white')(props),
            borderColor: mode(
              'rgba(162, 176, 210, 0.28)',
              'rgba(255,255,255,0.08)',
            )(props),
            borderRadius: '18px',
            _placeholder: { color: 'secondaryGray.600' },
            _focusVisible: {
              borderColor: mode('brand.400', 'brand.300')(props),
              boxShadow: mode(
                '0 0 0 4px rgba(111, 66, 193, 0.10)',
                '0 0 0 4px rgba(174, 134, 242, 0.12)',
              )(props),
            },
          },
          icon: {
            color: mode('secondaryGray.700', 'whiteAlpha.900')(props),
          },
        }),
        mini: (props) => ({
          field: {
            bg: mode('transparent', 'navy.800')(props),
            border: '0px solid transparent',
            fontSize: '0px',
            p: '10px',
            _placeholder: { color: 'secondaryGray.600' },
          },
          icon: {
            color: 'secondaryGray.600',
          },
        }),
        subtle: (props) => ({
          box: {
            width: 'unset',
          },
          field: {
            bg: 'transparent',
            border: '0px solid',
            color: 'secondaryGray.600',
            borderColor: 'transparent',
            width: 'max-content',
            _placeholder: { color: 'secondaryGray.600' },
          },
          icon: {
            color: 'secondaryGray.600',
          },
        }),
        transparent: (props) => ({
          field: {
            bg: 'transparent',
            border: '0px solid',
            width: 'min-content',
            color: mode('secondaryGray.600', 'secondaryGray.600')(props),
            borderColor: 'transparent',
            padding: '0px',
            paddingLeft: '8px',
            paddingRight: '20px',
            fontWeight: '700',
            fontSize: '14px',
            _placeholder: { color: 'secondaryGray.600' },
          },
          icon: {
            transform: 'none !important',
            position: 'unset !important',
            width: 'unset',
            color: 'secondaryGray.600',
            right: '0px',
          },
        }),
        auth: (props) => ({
          field: {
            bg: 'transparent',
            border: '1px solid',

            borderColor: 'secondaryGray.100',
            borderRadius: '16px',
            _placeholder: { color: 'secondaryGray.600' },
          },
        }),
        authSecondary: (props) => ({
          field: {
            bg: 'transparent',
            border: '1px solid',

            borderColor: 'secondaryGray.100',
            borderRadius: '16px',
            _placeholder: { color: 'secondaryGray.600' },
          },
        }),
        search: (props) => ({
          field: {
            border: 'none',
            py: '11px',
            borderRadius: 'inherit',
            _placeholder: { color: 'secondaryGray.600' },
          },
        }),
      },
    },
    // PinInputField: {
    //   variants: {
    //     main: (props) => ({
    //       field: {
    //         bg: "red !important",
    //         border: "1px solid",
    //         color: mode("secondaryGray.900", "white")(props),
    //         borderColor: mode("secondaryGray.100", "whiteAlpha.100")(props),
    //         borderRadius: "16px",
    //         _placeholder: { color: "secondaryGray.600" },
    //       },
    //     }),
    //   },
    // },
  },
};
